import {
  DEFAULT_GRID_PREFERENCE,
  sanitizeGridPreference,
  applyColumnOrder,
  JobsColumnsPopover,
} from '../jobs/JobsColumnsHelper';

export const GRID_PREFERENCES_STORAGE_KEY = 'accountingGridPreferences';

export { DEFAULT_GRID_PREFERENCE, sanitizeGridPreference, applyColumnOrder };
export const AccountingColumnsPopover = JobsColumnsPopover;

/**
 * Parse accounting grid preferences keyed by view mode (`description` | `ar-ap`).
 * Migrates legacy flat `{ columnOrder, columnVisibilityModel }` into `description`.
 */
export const parseGridPreferences = () => {
  const stored = window.localStorage.getItem(GRID_PREFERENCES_STORAGE_KEY);
  if (!stored) {
    return {};
  }

  try {
    const parsed = JSON.parse(stored);
    if (!parsed || typeof parsed !== 'object') {
      return {};
    }

    // Legacy single-preference shape (pre Description/AR-AP toggle).
    if (Array.isArray(parsed.columnOrder) || parsed.columnVisibilityModel) {
      return { description: parsed };
    }

    return parsed;
  } catch {
    return {};
  }
};
